import Meta from '@/components/common/Meta'
import { META_CONTENTS } from '@/v1/constants/seo'
import SummerCampShippingPage from '@/v2/components/pages/public-pages/summer-camp-shipping-page'
import { faqSectionContent, metaImages, ogImages } from '@/v2/constants/pages/public-pages/summer-camp-shipping-page'

interface SummerCampShippingPageProps {}

const Page: React.FC<SummerCampShippingPageProps> = () => {
  return (
    <>
      <Meta
        title={META_CONTENTS.summer_camp_shipping.title ?? ''}
        keywords={META_CONTENTS.summer_camp_shipping?.keywords ?? ''}
        description={META_CONTENTS.summer_camp_shipping?.description ?? ''}
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />

      <SummerCampShippingPage />
    </>
  )
}

export default Page
